import { SAVE_LIST } from '../actions/types';

const initialState = {
	
};

const listReducer = (state, action) => {
	if(!state) {return initialState;}
	
	switch(action.type) {
		case SAVE_LIST:
			return {
				...state,
				...action.data
			};
		default:
			return state;
	}
};

export default listReducer;